import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class AdvanceReturnValueLessThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.advance-return-value.less-than-zero');
    }
}
